"use client";

import {JSX, ReactNode} from "react";

import {ButtonBase} from "@/shared/ui/buttons/button-base";

import "./styles/search-drawer-footer.scss";

export type SubmitVariant = "primary" | "secondary-outline";

export interface SearchDrawerFooterProps {
    children?: ReactNode;
    onClear?: () => void;
    onSubmit?: () => void;
    clearLabel?: string;
    submitLabel?: string;
    submitVariant?: SubmitVariant;
    isLoading?: boolean;
}

export function SearchDrawerFooter({
    children,
    onClear,
    onSubmit,
    clearLabel = "Clear all",
    submitLabel = "Next",
    submitVariant = "secondary-outline",
    isLoading = false,
}: SearchDrawerFooterProps): JSX.Element {
    return (
        <div className="search-drawer-footer">
            {children && <div className="search-drawer-footer__content">{children}</div>}
            <div className="search-drawer-footer__actions">
                <ButtonBase variant="secondary" size="sm" onClick={onClear} disabled={isLoading}>
                    {clearLabel}
                </ButtonBase>
                <ButtonBase variant={submitVariant} size="sm" onClick={onSubmit} loading={isLoading}>
                    {submitLabel}
                </ButtonBase>
            </div>
        </div>
    );
}
